import operate from './operate'

export default function () {
  const { scoringMethod } = this.reviewGroupInfo
  const titleMap = {
    'BOE_REPORT_LIST': '项目名称',
    'BOE_REPORT_LIST_JCBDLX01': '姓名',
    'BOE_REPORT_LIST_JCBDLX02': '团队名称',
    'BOE_REPORT_LIST_JCBDLX03': '组织名称',
    'BOE_REPORT_LIST_JCBDLX04': '项目名称',
    'BOE_REPORT_LIST_JCBDLX05': '社会荣誉名称',
    'BOE_EVENT_INFO': '活动名称'
  }
  return [
    {
      title: '排序',
      width: 60,
      [$field]: 'objectOrderNum'
    },
    {
      title: titleMap[this.businessCode],
      [$field]: 'objectName'
    },
    {
      title: '轮次序号',
      width: 76,
      [$field]: 'maxReviewRoundNum'
    },
    scoringMethod !== 'DFFS03' ? {
      title: '总分',
      width: 60,
      [$field]: 'objectCountScore'
    } : null,
    scoringMethod !== 'DFFS03' ? {
      title: '平均分',
      width: 70,
      [$field]: 'objectAvgScore'
    }: null,
    scoringMethod !== 'DFFS03' ? {
      title: '去极平均分',
      [$field]: 'objectDepAvgScore'
    }: null,
    scoringMethod === 'DFFS03' ? {
      title: '最终定级',
      width: 76,
      [$field]: 'objectRank',
      render: (h, {row}) => {
        return h('span', this.dictMap[this.rankCode][row.objectRank])
      }
    } : null,
    {
      title: '意见',
      [$field]: 'objectOpinion',
      width: 300
    },
    {
      'title': '操作',
      'width': 180,
      [$field]: 'operate',
      'isOperate': true,
      'slotComponent': operate
    }
  ].filter(v => v)
}